<script setup>
const props = defineProps({
  highlightTestimonial: {
    type: String,
  },
  hideTestimonial: {
    type: String,
  }
})


const maxHeight = ref('auto')

onMounted(async () => {
  await nextTick()
  const heights = Array.from(document.querySelectorAll('.v-carousel-item'))
    .map(item => item.clientHeight)
  const tallest = Math.max(...heights)
  maxHeight.value = `${tallest+40}px`
})

let testimonials = [
  {
    text: "RM is awesome - everyone on my team across the country is a member & loves it. We use for business dinners & personally. Makes it easy for my wife & I to get last minute date nights at our favorite places & she says so fun!",
    name: "Justin Ishbia",
    company: "Managing Partner - Shore Capital Partners",
    company2: "Alternate Governor - Phoenix Suns, Phoenix Mercury",
    company3: "Member - YPO",
    type: "memberPlatinumVerified",
    profileId: "justinishbia"
  },
  {
    text: "I use RM for last-minute reservations in Chicago and all over the world. I love how convenient it is. I recommended RM to my co-stars and they also joined!",
    name: "Marina Squerciati",
    company: "Actor - NBC Universal",
    company2: "(Actress on TV’s Chicago PD, playing Kim Burgess for 11 years)",
    type: "memberPlatinumVerified",
    profileId: "marinasquerciati"
  },
  {
    text: "We have really enjoyed working with RM from the beginning. Our brands are in high demand & we always prioritize RM's referrals due to the quality of their members!",
    restaurantName: "Aba",
    restaurantGroup: "Lettuce Entertain You Restaurants",
    nameAndTitle: "Jacob Schwimmer - Director of Operations",
    type: "restaurantPreferred",
    profileId: "aba"
  },
  {
    text: "RM is the best reservation app! My go-to for securing reservations at top restaurants worldwide – gets me better access than my Black cards/services. My high-profile friends, including prominent athletes & team owners, enjoy it too.",
    name: "Les Coney",
    company: "Partner, Mesirow",
    company2: "Investor - RPM (LEYE), Sunda",
    company3: "Co-Owner - Chicago Sky",
    company4: "Member - FAENA ROSE",
    type: "memberPlatinumVerified",
    profileId: "lesterconey"
  },
  {
    text: "RM's model is overdue for the restaurant industry! Helps us capitalize on excess demand, offset inflation & better fill off peak times.",
    restaurantName: "La Serre",
    restaurantGroup: "DineAmic Hospitality",
    nameAndTitle: "Stephen Stoll - VP of Operations",
    type: "restaurantPreferred",
    profileId: "la-serre"
  },
  {
    text: "RM is one of the best employee benefits we've provided. Having restaurateurs friends & investing in restaurants, I already enjoyed great access - now with RM, my team does, too. I also don't have to text my friends anymore!",
    name: "Tony Davis",
    company: "Managing Partner & Co-Founder - Linden Capital Partners",
    company2: "Investor - Boka, RPM (LEYE), 4C",
    company3: "Member - YPO",
    type: "memberPlatinumVerified",
    profileId: "tonydavis"
  },
  {
    text: "We recommend RM to all of our good restaurateur friends! RM only sends us high end clients & makes it so easy for us - we hope they kill it!",
    restaurantName: "Chicago Cut Steakhouse",
    nameAndTitle: "Matthew Moore - Managing Partner",
    type: "restaurantPreferred",
    profileId: "chicago-cut"
  },
  {
    text: "My wife & I love RM. It's a lifesaver! We get all our reservations on it with access to the best restaurants on short notice.",
    name: "Harit Talwar",
    company: "Board Member - KPMG, Mastercard",
    company2: "Chairman - Better",
    type: "memberPlatinumVerified",
    profileId: "harittalwar"
  },

  // {
  //   text: "We love RM!  The referrals they send are great - high spenders who become regulars at zero cost to restaurants!  My partners & I use for our reservations too!",
  //   name: "Peter Lopez",
  //   company: "AGM, Adalina",
  //   type: "restaurantPreferred"
  // }
]

// if props.highlightedTestimonial we bring it to the top
const orderedTestimonials = computed(() => {
  let prependTestimonials = []
  let highlightedTestimonial = null
  if (props.highlightTestimonial) {
    highlightedTestimonial = testimonials.find(testimonial => testimonial.name == props.highlightTestimonial)
  }
  if (highlightedTestimonial) {
    prependTestimonials.push(highlightedTestimonial)
  }

  //remove any testimonials that match hideTestimonial
  if (props.hideTestimonial) {
    testimonials = testimonials.filter(testimonial => testimonial.name != props.hideTestimonial)
  }

  return prependTestimonials.concat(testimonials.filter(testimonial => testimonial.name != props.highlightTestimonial))
})
</script>

<template>
  <section class="pb-0">
    <div
      class=""
      style="text-align: -webkit-center;"
    >
      <VCarousel
        class="testimonial-holder"
        :height="maxHeight"
        show-arrows="hover"
        eager
        interval="10000"
        cycle
        hide-delimiter-background
      >
        <template #prev="{ props }">
          <VIcon
            color="primary"
            variant="elevated"
            @click="props.onClick"
          >
            mdi-chevron-left
          </VIcon>
        </template>
        <template #next="{ props }">
          <VIcon
            color="primary"
            variant="elevated"
            @click="props.onClick"
          >
            mdi-chevron-right
          </VIcon>
        </template>
        <VCarouselItem
          v-for="(testimonal, i) in testimonials"
          :key="i"
        >
          <div
            v-if="testimonal.type =='memberPlatinumVerified'"
            class="testimonial"
          >
            <p class="testimonial-text">
              {{ testimonal.text }}
            </p>
            <span class="testimonial-name">
              <RouterLink
                :to="`/m/${testimonal.profileId}`"
              >{{ testimonal.name }}</RouterLink></span>
            <span class="testimonial-company"><VIcon class="verified-icon">material-symbols:verified</VIcon>Platinum member</span>
            <span class="testimonial-company">{{ testimonal.company }}</span>
            <span
              v-if="testimonal.company2"
              class="testimonial-company"
            >{{ testimonal.company2 }}</span>
            <span
              v-if="testimonal.company3"
              class="testimonial-company"
            >{{ testimonal.company3 }}</span>
            <span
              v-if="testimonal.company4"
              class="testimonial-company"
            >{{ testimonal.company4 }}</span>
          </div>
          <div
            v-if="testimonal.type =='restaurantPreferred'"
            class="testimonial"
          >
            <p class="testimonial-text">
              {{ testimonal.text }}
            </p>
            <span class="testimonial-name">
              <RouterLink
                :to="`/r/${testimonal.profileId}`"
              >{{ testimonal.restaurantName }}</RouterLink></span>
            <span
              v-if="testimonal.restaurantGroup"
              class="testimonial-company"
            >({{ testimonal.restaurantGroup }})</span>
            <span class="testimonial-company"><VIcon style="margin-left: -3px;">iconamoon:certificate-badge-light</VIcon>Preferred</span>
            <span class="testimonial-company">{{ testimonal.nameAndTitle }}</span>
          </div>
        </VCarouselItem>
      </VCarousel>
    </div>
  </section>
</template>

<style lang="scss" scoped>
.testimonial-holder{
  max-width: 490px;
  padding-left: 1em;
  padding-right: 1em;
}

.testimonial {
  background: var(--ds-surface-card);
  padding: 1.6rem;
  margin-top: 1.4em;
  border-radius: var(--ds-radius-md);
  box-shadow: 0 12px 20px -10px rgba(0, 0, 0, 0.06);
  position: relative;
  border: thin solid rgba(0, 0, 0, 0.15);
  max-width: 460px;
  height:94%;
}
.verified-icon{
  color: rgb(0, 149, 246);
  width: 1.25rem;
  height: 1.25rem;
  margin-bottom: 3px;
  margin-right: 3px;
}

.v-window-item {
  transition: transform 1s cubic-bezier(0.25, 0.8, 0.5, 1) !important;
}
</style>
